// Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.scss']
})

export class AttachmentComponent {

    @Input() cta: string;
    @Input() accept: string;

    @Output() onChange: EventEmitter<any>;

    public file: File;
    public imgSrc;
    public thumbnail;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    constructor() {
        this.cta = 'Add photo or video';
        this.accept = 'image/*,video/*';
        this.onChange = new EventEmitter();

        console.log(this.imgSrc)
    }

  
    fileChangeEvent(event: any): void {
        if (!event.target.files.length) {
            return;
        }
        this.imageChangedEvent = event;
        this.file = event.target.files.item(0);
        if (this.file.type.match('image')) {

            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onloadend = () => {
                this.thumbnail = reader.result;

                const image = new Image();
                image.src = this.thumbnail;
                this.imgSrc = image.src;
                console.log(image.width, image.height);
                image.onload = () => {
                    this.onChange.emit({
                        file: this.file,
                        width: image.width,
                        height: image.height,
                        type: 'image',
                        isOriginal: true
                    });
                };
            };
        } else {
            this.onChange.emit({
                file: this.file,
                type: 'video',
                isOriginal: false

            });
        }
    }
    imageCropped(image: string) {
        this.imgSrc = image;
        this.file = this.dataURLtoFile(image)
        console.log(this.file);
        if (this.file.type.match('image')) {

            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onloadend = () => {
                this.thumbnail = reader.result;

                const image = new Image();
                image.src = this.thumbnail;
                this.imgSrc = image.src;
                console.log(image.width, image.height);
                image.onload = () => {
                    this.onChange.emit({
                        file: this.file,
                        width: image.width,
                        height: image.height,
                        type: 'image',
                        isOriginal: false

                    });
                };
            };
        } else {
            this.onChange.emit({
                file: this.file,
                type: 'video',
                isOriginal: false

            });
        }
    }
    imageLoaded() {
        // show cropper
    }
    loadImageFailed() {
        // show message
    }
    public remove(): void {
        this.thumbnail = null;
        this.file = null;
        this.onChange.emit(null);
    }
    dataURLtoFile(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.file.name, { type: mime });
    }
    randomString(length, chars) {
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }
    //Usage example:
    // var file = dataURLtoFile('data:text/plain;base64,aGVsbG8gd29ybGQ=', 'hello.txt');
    // console.log(file);
}
